import BatteryStdIcon from "@mui/icons-material/BatteryStd";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import PropaneTankIcon from "@mui/icons-material/PropaneTank";
import { DriveType } from "../models/mapAssetRow";

/**
 * The icon for a way of being powered. A pressurised tank stands for hydrogen.
 *
 * One table, because the label on the map and the row in the list both draw it: kept apart, a
 * changed icon would show in one place and not the other, and the two would then disagree about
 * what a vehicle runs on.
 */
export const DRIVE_TYPE_ICONS: Record<DriveType, typeof BatteryStdIcon> = {
  electric: BatteryStdIcon,
  combustion: LocalGasStationIcon,
  hydrogen: PropaneTankIcon,
};
